import React, {useEffect} from 'react';
import {Box, Grid, Typography} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { checkUserEnabled } from '../../helpers/authorizedUser';
import WithdrawForm from '../../components/WithdrawMetamaskForm';
import LastWithdrawTransactionsTable from '../../components/Withdraw/LastWithdrawTransactions';
import { GREEN_MAIN } from '../../theme/colors';
import WithdrawTypeForm from '../../components/WithdrawTypeForm';
import { isMobile } from 'react-device-detect';

const WithdrawTokens = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [loading, setLoading] = React.useState(true);
    const [statusResponse, setStatusResponse] = React.useState<boolean>(false)
    const {checkIsAuth} = useUserContext();
    const [title, setTitle] = React.useState<string>("");

    // utente autorizzato
    const {user, auth} = useUserContext();
    useEffect(()=>{
        if (!auth.isLoading) {
            if (!auth.isAuthenticated) {
                navigate('/');
            } else {
                if(user){
                    if(!checkUserEnabled(user)){
                        navigate('/');
                    }
                }
                setLoading(false);
            }
        }
        checkIsAuth().finally();
    },[auth.isAuthenticated, auth.isLoading, navigate, user, ])
    // fine utente autorizzato

    return(
        <>
            <Box sx={{
                width:'100%', 
                display:'flex', 
                flexDirection:'column',
                color: GREEN_MAIN,
                fontFamily:'poppins'
            }}>
                {
                    auth.isAuthenticated && 
                    <>
                        {/* Main title */}
                        <Typography
                            variant="h3"
                            component="h1"
                            gutterBottom
                            sx={{
                                mb: 10,
                                mt:!isMobile ? 10 : 0,
                                fontWeight: "bold",
                            }}
                        >
                            {t(title)}
                        </Typography>

                        <WithdrawTypeForm setTitle={setTitle}/>
                        
                    </>
                }
            </Box>
        </>
    )
}

export default WithdrawTokens;